import React from 'react'
import { css } from '../style/styles'
const DeleteConfirm = ({setDeleteConfirm, deleteContract, deleteConfirm}) => {
    return (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ background: "#fff", borderRadius: 14, width: 380, padding: 28, textAlign: "center", boxShadow: "0 20px 60px rgba(0,0,0,0.25)" }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>⚠️</div>
                <div style={{ fontWeight: 800, fontSize: 16, marginBottom: 8 }}>Xác nhận xóa hợp đồng</div>
                <div style={{ color: "#64748b", fontSize: 13, marginBottom: 24 }}>Hành động này không thể hoàn tác.</div>
                <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                    <button style={css.btn("ghost")} onClick={() => setDeleteConfirm(null)}>Hủy</button>
                    <button style={css.btn("danger")} onClick={() => deleteContract(deleteConfirm)}>Xóa hợp đồng</button>
                </div>
            </div>
        </div>
    )
}

export default DeleteConfirm